import { useMarkAllAsReadNotificationMutation } from '@/types/generated/graphql';
import { notification } from 'antd';

export function useMarkAllRead() {
  const [markAllRead, { loading }] = useMarkAllAsReadNotificationMutation({
    onCompleted: ({ markAllAsReadNotification }) => {
      notification.success({ message: markAllAsReadNotification?.message });
    },
    update: (cache) => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'getAllNotificationV2' });
      cache.gc();
    },
  });

  return {
    markAllRead,
    loading,
  };
}
